/* The journal listing: the mobile contents sheet. Everything else on the page
   is a link, so there is nothing else to script. */
(function () {
  'use strict';
  var menu = document.querySelector('[data-blog-menu]');
  if (!menu) return;
  var open = document.querySelector('[data-blog-menu-open]');
  var close = document.querySelector('[data-blog-menu-close]');
  function show(on) {
    menu.classList.toggle('is-active', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  if (open)  open.addEventListener('click', function () { show(true); });
  if (close) close.addEventListener('click', function () { show(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu.classList.contains('is-active')) show(false);
  });
  /* Picking a tag navigates, so the sheet does not need to close itself. */
})();
